module.exports = __webpack_public_path__ + "img/imagen-fondo-g.b5c36176.png";